import { render } from "./AwardsGrid.vue?vue&type=template&id=87e060b8"
import script from "./AwardsGrid.vue?vue&type=script&lang=js"
export * from "./AwardsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__